/* eslint-disable no-debugger */
import { useEffect, useState } from 'react';
import useMeetClassificationFlatData from '../../../state/meet/meetClassificationFlat/UseMeetClassificationFlatData';

const useMeetTypeMultiSelect = (filterIds) => {
  const { meetClassificationFlatState, getMeetClassificationFlat } = useMeetClassificationFlatData();
  const [options, setOptions] = useState([]);

  useEffect(() => {
    if (meetClassificationFlatState.isArrayLoading === false && meetClassificationFlatState.isArrayLoaded === false) {
      getMeetClassificationFlat(false, false, false);
    } else if (meetClassificationFlatState.isArrayLoading === false && meetClassificationFlatState.isArrayLoaded === true) {
      const meetTypeOptions = [];

      const filterIdArray = filterIds && filterIds.length > 0 ? filterIds.split(',').map(id => id) : [];

      for (const meetType of meetClassificationFlatState.arrayData) {
        if (meetType.parentId > 0 && (filterIdArray.length === 0 || filterIdArray.includes(meetType.parentId.toString()))) {
          meetTypeOptions.push({ id: meetType.meetClassificationId, name: meetType.typeName });
        }
      }

      setOptions(meetTypeOptions.sort((a, b) => a.name.localeCompare(b.name)));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [meetClassificationFlatState, filterIds]);

  return {
    meetClassificationFlatState,
    options
  };
};

export default useMeetTypeMultiSelect;